import mail from "../../assets/icons/mail.svg";
import linkedin from "../../assets/icons/linkedin.svg";
import github from "../../assets/icons/github.svg";

export const data = [
    {
        name: "Email",
        img: mail,
        link: "mailto:dbinlee.3@gmail.com",
    },
    {
        name: "LinkedIn",
        img: linkedin,
        link: "https://www.linkedin.com/in/benlee12/"
    },
    {
        name: "Github",
        img: github,
        link: "https://github.com/dbinlee3"
    }
]